import SharedCart from "pages/cart/Cart";
import { StorefrontLayoutProvider } from "storefronts/StorefrontLayoutBridge";
import StorefrontLayout from "../components/StorefrontLayout";

export default function CartPage() {
  return (
    <StorefrontLayoutProvider layout={StorefrontLayout}>
      <SharedCart />
    </StorefrontLayoutProvider>
  );
}
